
<template>
  <div  class="root-container">


  </div>
</template>

<style>
</style>

<script>
  import globaldata from "../../../utils/globaldata";
  import messageUtils from "../../../utils/messageUtils";
  import commonUtils from "../../../utils/commonUtils";

  export default {
    name: 'UserDetailInfo',
    props: {
      show:Object,

    },
    data() {
      return {

      }
    },
    created(){

      this.initData();
    },
    methods: {
      initData(){
      }
    },


  }
</script>






// WEBPACK FOOTER //
// src/views/user-by-lesson-card/components/UserDetailInfo.vue